import React from 'react';
import './style.css';
import SearchContainerView from '../../components/search-container-view';
import { useAppSelector } from "../../redux/hooks";
import { selectCustomer } from "../../redux/slices/customer-slice";
import AppWrapper from '../../components/base/app-wrapper';
import { selectPaymentsStore } from '../../redux/slices/payments-slice';
import { selectNotificationStore } from '../../redux/slices/notification-slice';

export default function SearchViewPage() {
  const customer = useAppSelector(selectCustomer());
  const payments = useAppSelector(selectPaymentsStore());
  const notification = useAppSelector(selectNotificationStore());

  return (
    <AppWrapper
      customer={customer}
      loading={customer.status === 'loading' || payments.status === 'loading'}
      errorDialog={notification?.errorDialog}
    >
      <div className="search-container">
        <SearchContainerView />
      </div>
    </AppWrapper>
  );
}
